module.exports = __webpack_public_path__ + "static/media/money2.fa6620b0.jpg";